'use client';

import { useTranslations } from 'next-intl';
import type { PropertyDetailListing } from '@/src/components/features/property/types';
import { type ListingActionAnalyticsContext, useListingActions } from '@/src/components/features/listing-actions';
import * as styles from './listingFeedbackModule.styles';

type Props = {
  listing: PropertyDetailListing;
};

const LISTING_FEEDBACK_ANALYTICS: ListingActionAnalyticsContext = {
  triggerLocation: 'home_details_halo',
  triggerObject: 'home_details_component|listing_feedback',
};

/**
 * "Spot something off?" feedback footer.
 */
export const ListingFeedbackModule = ({ listing }: Props) => {
  const t = useTranslations('hdp');
  const { listingHidden, toggleHide, openReport } = useListingActions(listing, LISTING_FEEDBACK_ANALYTICS);

  if (!listing) return null;

  return (
    <div className={styles.container}>
      <div className={styles.reportSection}>
        <span className={styles.reportHeading}>{t('feedbackHeading')}</span>
        <span className={styles.reportDescription}>{t('feedbackDescription')}</span>
        <div className={styles.actionRow}>
          <button type="button" className={styles.reportLink} onClick={openReport}>
            {t('reportListing')}
          </button>
          <span className={styles.separator} aria-hidden="true">
            |
          </span>
          <button type="button" className={styles.reportLink} onClick={toggleHide}>
            {listingHidden ? t('unhideListing') : t('hideListing')}
          </button>
        </div>
      </div>
    </div>
  );
};
